import { apiCallback } from 'api';
import { ApiCallArgs } from 'api/types';
import { TIMEOUT_CONFIG } from 'constants/checkout-api-timeout';
import type { OrderStatus } from 'constants/orderStatus';
import { Slot } from 'redux/modules/order/state/initial-state';

const definition = {
  defaultVersion: 1,
  endpoint: 'orders',
  query: {
    size: '${size}',
    sortBy: '${sortBy}',
    start: '${start}',
    statuses: '${statuses}',
  },
  service: 'order-orchestration',
  verbs: ['get'],
  timeout: TIMEOUT_CONFIG,
};

/**
 * **Warning: several fields are missing**
 */
export interface Order {
  customerOrderId: string;
  status: OrderStatus;
  /** DateTime */
  created: string;
  placedAt?: 'HOME' | 'PHONE' | 'BRANCH';
  /** DateTime */
  lastUpdated: string;
  bagless: boolean;
  substitutionsAllowed: boolean;
  paperStatement: boolean;
  alerts?: ('SMS' | 'PUSH' | 'EMAIL')[];
  alcoholPresent: boolean;
  deliveryNote?: string;
  contactNumber?: string;
  slots: Partial<Slot>[];
}

/**
 * **Warning: the links field is missing**
 */
export interface PageableOrdersResponse {
  content: Order[];
}

const getOrders: (
  args: {
    size: number;
    sortBy: '+' | '-';
    start: number;
    /**
     * A list of {@link OrderStatus} separated by `+`
     */
    statuses: string;
  } & ApiCallArgs,
) => WtrApiCall<PageableOrdersResponse> = apiCallback(definition, 'get');

export default {
  get: getOrders,
};
